import styles from './Topbar.module.css';
import { useState, useEffect, useRef } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Topbar = () => {
  const [showIamMenu, setShowIamMenu] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  // Click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowIamMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = async () => {
    await logout();
    navigate('/iam/login');
  };

  return (
    <div className={styles.topbar}>
      <span className={styles.logo}>The Gottman Initiative</span>

      {user && (
        <div className={styles.iamDropdown} ref={dropdownRef}>
          <button
            className={styles.iamButton}
            onClick={() => setShowIamMenu(!showIamMenu)}
            aria-expanded={showIamMenu}
            aria-label="User menu"
          >
            <span className={styles.username}>👤 {user.username}</span>
          </button>

          {showIamMenu && (
            <div className={styles.iamMenu}>
              {user.role === 'admin' && (
                <NavLink
                  to="/iam/manage-users"
                  className={({ isActive }) =>
                    `${styles.iamMenuItem} ${isActive ? styles.active : ''}`
                  }
                  onClick={() => setShowIamMenu(false)}
                >
                  Manage Users
                </NavLink>
              )}
              <NavLink
                to="/iam/change-password"
                className={({ isActive }) =>
                  `${styles.iamMenuItem} ${isActive ? styles.active : ''}`
                }
                onClick={() => setShowIamMenu(false)}
              >
                Change Password
              </NavLink>
              <button className={styles.iamMenuItem} onClick={handleLogout}>
                Logout
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Topbar;
